const actions = [
    {
        title: 'Офисы и банкоматы',
        icon: 'icons/location.svg',
        name: 'offices',
    },
    {
        title: 'Ростов-на-Дону',
        icon: 'icons/compass-arrow.svg',
        name: 'location',
    },
    {
        title: 'Курсы валют',
        icon: 'icons/dollar.svg',
        name: 'currency-rates',
    },
];

const languages = [
    {
        title: 'En',
        name: 'en',
    },
    {
        title: 'Zh',
        name: 'zh',
    },
];

export {
    actions,
    languages,
};
